const JPG = 'image/jpeg';
const PNG = 'image/png';

export const isInvalidFile = (file: File) =>
	file.type !== JPG && file.type !== PNG;
export const isValidFile = (file: File) =>
	file.type === JPG || file.type === PNG;
